import { Component, HostListener } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';//获取手机硬件设备
import { Platform, MenuController, NavController, IonApp, AlertController, ModalController, ActionSheetController, PopoverController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { BaseModal } from '../../src/model/base';
import { Router, NavigationEnd, NavigationStart, NavigationError, NavigationCancel, ActivatedRoute } from '@angular/router';
// import { CommonService } from '../service/common.service';
import { IndexService as CommonService } from '../service/common/index.service';
import { MessageclientService } from '../service/messageclient.service';
import { NativeService } from '../service/native.service';//硬件调用
import { Subscription } from 'rxjs';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { AppUpdate } from '@ionic-native/app-update/ngx';//android更新版本
import { SignalrclientService } from '../service/signalrclient.service';//消息推送
import { AppMinimize } from '@ionic-native/app-minimize/ngx';//最小化
import { AppServiceBaseCase } from './app.service.basecase';
import { HttpCustomerService } from '../service/httpcustomer.service';//请求地址
import { AppConfig } from '../app/app.config';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';//键盘事件
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { IndexService as WeChatService } from "../service/wechat/index.service";
import * as $ from 'jquery';

declare var app;
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    providers: [AppMinimize, IonApp, AppServiceBaseCase]
})
export class AppComponent {
    public appPages: Array<any> = [];
    public userinfo: any;
    sideMenuDisabled = true;
    backButtonPressed: boolean = false; //用于判断返回键是否触发
    backExitApp: boolean = false;//用于判断是否双击触发
    customBackActionSubscription: Subscription;
    isAndroidPlatform: boolean = false;//安卓平台
    isIosPlatform: boolean = false;//ios平台
    isbackButton: boolean = false;//判断是否弹出
    isAndroid4: boolean = false;//是否是安卓4以下
    isAndroid5Down: boolean = false;//是否是安卓5以下
    isAndroid5: boolean = false;//是否是安卓5
    url: string;
    PageName:string;
    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        public base: BaseModal,
        private router: Router,
        private menusC: MenuController,
        public navController: NavController,//导航控制器
        private common: CommonService,
        private msg: MessageclientService,
        private screen: ScreenOrientation,
        private appUpdate: AppUpdate,
        private appMinimize: AppMinimize,//最小化
        private appversion: AppVersion,//版本号
        private iab: InAppBrowser,//跳转链接
        private http: HttpCustomerService,//http请求连接
        private native: NativeService,
        private device: Device,
        public keyboard: Keyboard,
        public alertCtrl: AlertController,
        public modalCtrl: ModalController,
        public actionSheetCtrl: ActionSheetController,
        public popoverCtrl: PopoverController,
        private signalr: SignalrclientService,//消息推送
        private actRouter: ActivatedRoute,
    ) {
        this.initializeApp();
        this.KeyBoard();

    }
    loginOut() {
        this.common.LoginOut();
    }
    SubMenusOpen(root: any) {
        // console.log("12121212");
        this.menusC.toggle();

        if (root.Url) {
            this.router.navigateByUrl('/tabs/' + root.Url);
        }
    }
    initializeApp() {
        const that = this;

        // that.getBrowserKernel();
        that.initRouterListen();
        that.platform.ready().then(() => {

            that.common.GetStaticObject();
            if (that.platform.is("cordova")) {
                that.screen.lock(that.screen.ORIENTATIONS.PORTRAIT_PRIMARY);//防止屏幕旋转
                // that.getIosAppVersion();

                that.keyboard.onKeyboardShow().subscribe((data) => {
                    console.log("onKeyboardShow 订阅");
                    that.KeyBoard();
                })
                that.KeyBoard();

                //  console.log(navigator.appVersion);
                // that.appUpdate.checkAppUpdate(app.ANDROID_INSTALL_URL).then(data=>{
                // console.log(data);
                // });
                //   that.signalr.NotificationMessage({
                //     id: 1,
                //     title: '你有新的消息,请注意查收',
                //     sound: 'file://sound.mp3',
                //     text: '明天中午12点开会',
                //     icon: 'http://example.com/icon.png',
                //     trigger: {at: new Date(new Date().getTime() + 3600)},
                //     clock:true,
                //     lockscreen:true
                //  });
                //  that.signalr.NotificationClickEvent().then((data)=>{
                //   alert(data.title);
                //   console.log(data);
                //  },error=>{
                //   alert(error);
                //  })
                if (that.platform.is("ios")) {
                    that.isIosPlatform = true;
                }
                if (that.platform.is("android")) {
                    that.isAndroidPlatform = true;
                    that.statusBar.overlaysWebView(true);
                    that.MobileModel();
                    // that.registerBackButtonAction();
                    that.platform.resume.subscribe();
                    if (that.device.version) {//版本号存在
                        if (that.device.version.toString().startsWith("5")) {//当前版本小于等于5.0
                            that.isAndroid5 = true;//等于5
                            that.isAndroid5Down = true;
                            that.isAndroid4 = false;
                        } else if (that.device.version.toString().startsWith("4")) {//当前版本小于等于4.0
                            that.isAndroid5Down = true;//小于5.0
                            that.isAndroid4 = true;
                        } else if (that.device.version.toString().startsWith("3")) {//当前版本小于等于3.0
                            that.isAndroid5Down = true;//小于5.0
                            that.isAndroid4 = true;
                        }
                    }
                }
            }
            that.statusBar.styleDefault();
            that.splashScreen.hide();
            // console.log(this.isIosPlatform,this.isAndroidPlatform);
            if (!that.platform.is("cordova")) {
                that.WXBackEventFun();
            }


        });
    }
    WXBackEventFun() {
        const that = this;
        history.pushState(null, null, document.URL);
        let preTime: number = new Date().getTime();//初始化时间戳
        window.addEventListener("popstate", async (e) => {
            history.pushState(null, null, document.URL);
            const currentTime: number = new Date().getTime();//返回键时间戳
            if (currentTime - preTime >= 400) {
                preTime = currentTime;
                setTimeout(() => {
                    that.backEventFun();
                }, 100);
            }
            return;
        }, false);
        // that.weChatService.IsWeChatConfig().then(res=>{
        //   wx.onHistoryBack(function(){

        //     console.log("weixin返回事件！！！！！！！！");
        //     return false;
        //     // that.backEventFun();
        //   });
        // })
    }

    async backEventFun() {
        const that = this;
        try {
            that.keyboard.hide();//键盘事件
            const alert = await that.alertCtrl.getTop();
            if (alert) {
                if (!that.common.GetStorageKey("ISCLOSE")) {
                    that.isbackButton = false;
                    alert.dismiss();
                } else {
                    that.msg.Show("请先操作弹出框");
                }
                return;
            }
            const action = await that.actionSheetCtrl.getTop();
            if (action) {
                that.isbackButton = false;
                action.dismiss();
                return;
            }
            const popover = await that.popoverCtrl.getTop();
            if (popover) {
                that.isbackButton = false;
                popover.dismiss();
                return;
            }
            const modal = await that.modalCtrl.getTop();
            if (modal) {
                that.isbackButton = false;
                modal.dismiss();
                return;
            }
            const isOpen = await that.menusC.isOpen();
            if (isOpen) {
                that.isbackButton = false;
                that.menusC.close();
                return;
            }

            const dateTime2: any = document.getElementsByClassName("ios-select-widget-box");
            if (dateTime2.length > 0) {
                for (let i = 0; i < dateTime2.length; i++) {
                    dateTime2[i].remove();
                }
                return;
            }
        } catch (error) {

        }
        if (that.url.trim()) {
            if (that.url == "/login" || that.url == "/") {
                if (that.common.IsWeixinBrowser) {
                    history.pushState(null, null, null);
                } else {
                    that.appMinimize.minimize();
                }
                return;
            }
            if (that.common.getFirstMenuUrl(that.url)) {
                if (!that.isbackButton) {
                    that.isbackButton = true;
                    that.msg.Confirm("确定退出系统吗?", "取消", "退出").then(fail => {
                        that.isbackButton = false;
                        if (fail) {
                              navigator['app'].exitApp();
                        }
                    });
                }
            } else if (location.href && (location.href.indexOf("/exam/exam/") > -1 || location.href.indexOf("/exam/examTemporary/") > -1)) {
                
            } else if (location.href && location.href.indexOf("face-identification") > -1) {
                that.common.Go("/login");
            } else {

                //#endregion
                if (that.url.indexOf("qrcode") != -1) {//二维码页面
                    that.common.goBack(false);
                } else {
                    that.common.goBack();
                }
            }
        } else {
            if (!that.isbackButton) {
                that.isbackButton = true;
                that.msg.Confirm("确定退出系统吗?", "取消", "退出").then(fail => {
                    that.isbackButton = false;
                    if (fail) {
                         navigator['app'].exitApp();
                    }
                    
                });
            }
        }
    }

    getIosAppVersion() {
        let that = this;
        let htpFile: any = "";
        if (app.RELEASE) {
            htpFile = app.IOS_INSTALL_URL;
        } else {
            htpFile = app.IOS_INSTALL_URL_TEST;
        }
        that.http.get(htpFile).then(resu => {
            let version: any = 0;//相同版本
            if (that.platform.is("ios") || that.platform.is("ipad") || that.platform.is("iphone")) {
                version = resu.ios.version;
            } else if (that.platform.is("android")) {
                version = Number.parseInt(resu.android.version);
            }
            that.appversion.getVersionCode().then(num => {
                if (num != version) {
                    that.msg.Alert(app.CONTENT, "更新提示", "立即更新").then(fail => {
                        if (fail) {
                            that.KeyBoard();
                            if (that.platform.is("ios") || that.platform.is("ipad") || that.platform.is("iphone")) {
                                if (!app.RELEASE) {
                                    that.iab.create(app.IOS_URL_TEST);
                                } else {
                                    that.iab.create(app.IOS_URL);
                                }
                            } else if (that.platform.is("android")) {
                                that.native.downloadApp();
                            }
                        }
                    });

                }

            });
        });

    }
    registerBackButtonAction() {
        const that = this;
        that.customBackActionSubscription = that.platform.backButton.subscribe(() => {
            if (that.common.getMenusUrl(that.url)) {
                if (this.backButtonPressed) {
                    this.appMinimize.minimize();
                    this.backButtonPressed = false;
                } else {
                    that.msg.Show("再按一次退出应用");
                    this.backButtonPressed = true;
                    setTimeout(() => {
                        this.backButtonPressed = false
                        navigator['app'].exitApp();
                    }, 2000);
                }
            } else {
                this.navController.back();
            }
        });
    }


    // @HostListener('document:ionBackButton', ['$event'])
    // private overrideHardwareBackAction($event: any) {
    //     const that = this;
    //     //  console.log("监听事件...");
    //     $event.detail.register(100, async () => {
    //         console.log("返回按钮...");
    //         //  console.log( that.url);
    //         try {
    //             that.keyboard.hide();//键盘事件
    //             const alert = await that.alertCtrl.getTop();
    //             if (alert) {
    //                 if (!that.common.GetStorageKey("ISCLOSE")) {
    //                     that.isbackButton = false;
    //                     alert.dismiss();
    //                 } else {
    //                     that.msg.Show("请先操作弹出框");
    //                 }
    //                 return;
    //             }
    //             const action = await that.actionSheetCtrl.getTop();
    //             if (action) {
    //                 that.isbackButton = false;
    //                 action.dismiss();
    //                 return;
    //             }
    //             const popover = await that.popoverCtrl.getTop();
    //             if (popover) {
    //                 that.isbackButton = false;
    //                 popover.dismiss();
    //                 return;
    //             }
    //             const modal = await that.modalCtrl.getTop();
    //             if (modal) {
    //                 that.isbackButton = false;
    //                 modal.dismiss();
    //                 return;
    //             }
    //             const isOpen = await that.menusC.isOpen();
    //             if (isOpen) {
    //                 that.isbackButton = false;
    //                 that.menusC.close();
    //                 return;
    //             }

    //             const dateTime2: any = document.getElementsByClassName("ios-select-widget-box");
    //             if (dateTime2.length > 0) {
    //                 for (let i = 0; i < dateTime2.length; i++) {
    //                     dateTime2[i].remove();
    //                 }
    //                 return;
    //             }
    //         } catch (error) {

    //         }
    //         if (that.url.trim()) {
    //             if (that.url == "/login" || that.url == "/") {
    //                 that.appMinimize.minimize();
    //                 return;
    //             }
    //             if (that.common.getFirstMenuUrl(that.url)) {
    //                 if (!that.isbackButton) {
    //                     that.isbackButton = true;
    //                     that.msg.Confirm("确定退出系统吗?", "取消", "退出").then(fail => {
    //                         that.isbackButton = false;
    //                         if (fail) {
    //                             navigator['app'].exitApp();
    //                         }
    //                     });
    //                 }

    //             } 
    //             else {
    //                 that.common.goBack();
    //             }
    //         } else {
    //             if (!that.isbackButton) {
    //                 that.isbackButton = true;
    //                 that.msg.Confirm("确定退出系统吗?", "取消", "退出").then(fail => {
    //                     that.isbackButton = false;
    //                     if (fail) {
    //                         navigator['app'].exitApp();
    //                     }
    //                 });
    //             }
    //         }
    //         return;
    //     });
    // }
    @HostListener('document:ionBackButton', ['$event'])
    private overrideHardwareBackAction($event: any) {
      const that = this;
      //  console.log("监听事件...");
      $event.detail.register(100, async () => {
        console.log("返回按钮...");
        //  console.log( that.url);
        that.backEventFun();
        return;
      });
    }
    getBrowserKernel() {
        let ua = navigator.userAgent;
        let key = "TBS/";
        let start = ua.indexOf(key);
        if (start !== -1) {
            alert("X5内核");
        } else {
            alert("系统内核");
        }
    }
    // registerBackButtonAction() {
    //   let that = this;
    //   that.customBackActionSubscription = this.platform.backButton.subscribe(() => {
    //     if (that.backButtonPressed) {
    //       if (!that.backExitApp) {
    //         that.backExitApp = true;
    //         that.msg.Confirm("确定退出程序吗？").then(data => {
    //           that.backButtonPressed = false;
    //           that.backExitApp = false;
    //           if (data) {
    //             navigator['app'].exitApp();
    //           } else {
    //             that.router.initialNavigation();
    //           }
    //         });
    //       }
    //     } else {
    //       if (!that.backExitApp) {
    //         that.backButtonPressed = true;
    //         if (that.common.getMenusUrl(that.url)) {
    //           that.router.dispose();
    //           that.router
    //           that.backExitApp = true;
    //           that.msg.Confirm("确定退出程序吗？").then(data => {
    //             that.backButtonPressed = false;
    //             that.backExitApp = false;
    //             if (data) {
    //               navigator['app'].exitApp();
    //             } else {
    //               that.router.initialNavigation();
    //             }
    //             setTimeout(function () {
    //               that.backButtonPressed = false;
    //             }, 2000);
    //           });
    //         }
    //         else {
    //           setTimeout(function () {
    //             that.backButtonPressed = false;
    //           }, 2000);
    //           that.router.initialNavigation();
    //         }
    //       }
    //     }
    //   });
    // }
    initRouterListen() {
        const that = this;
        that.router.events.subscribe(event => { // 需要放到最后一个执行
            if (event instanceof NavigationStart) {
                // console.log(event.url);
                // if(event.url !="/"){
                //   that.msg.Loading("请稍后...","load").then((lod)=>{
                //     lod.present();
                //    });
                // }
            }
            if (event instanceof NavigationEnd) {

                if(!that.platform.is("cordova")){
                    window.history.pushState(null,null,document.URL);
                  }
                that.url = event.url;
                if (that.common.getFirstMenuUrl(that.url)) {
                    that.base.IsMenusHome = true;
                    //  if(that.base.UrlAction){
                    //   that.base.UrlAction = that.common.replaceMenusUrl(that.url);
                    //  }
                    that.base.IsMenusAction = that.common.getMenuAction(that.url);
                } else {
                    that.base.IsMenusHome = false;
                    // that.base.UrlAction = undefined;
                }
                //  console.log(document.getElementsByName("tabs"));

            }
            // if (event instanceof NavigationEnd) {
            //   that.url = event.url;
            //   if(event.url !="/"){
            //     setTimeout(()=>{
            //       that.msg.LoadingDismiss("load");
            //     },1000);
            //   }

            // }
            // if(event instanceof NavigationError){
            //   if(event.url !="/"){
            //     setTimeout(()=>{
            //       that.msg.LoadingDismiss("load");
            //     },1000);
            //   }
            // }
            // if(event instanceof NavigationCancel){
            //   if(event.url !="/"){
            //     setTimeout(()=>{
            //       that.msg.LoadingDismiss("load");
            //     },1000);
            //   }
            // }
        });
    }
    ngAfterViewInit() {

        let ConfigName = this.actRouter.snapshot.paramMap.get("ConfigName");
        console.log("current page",ConfigName);
        // window.addEventListener('native.keyboardshow', function (e) {
        //   // todo 进行键盘可用时操作
        //   //e.keyboardHeight 表示软件盘显示的时候的高度
        //   console.log("输入法唤起",e);
        // });

        // window.addEventListener('native.keyboardhide', function (e) {
        //     // todo 进行键盘不可用时操作
        //     var keyitem = document.getElementsByClassName("keyboard-bottom");
        //     keyitem[keyitem.length - 1]["style"] = "padding-bottom: 0px;";
        //     console.log("输入法隐藏ks", e);
        // });

        // var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;

        // window.onresize = function () {
        //     //键盘弹起与隐藏都会引起窗口的高度发生变化
        //     var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //     if (resizeHeight - 0 < originalHeight - 0) {
        //         //当软键盘弹起，在此处操作
        //         // $("#ibo-window-bottom").css("display","none"); //隐藏按钮
        //         console.log("隐藏按钮");
        //     } else {
        //         //当软键盘收起，在此处操作
        //         // $("#ibo-window-bottom").css("display","block");//显示按钮
        //         console.log("显示按钮");
        //     }
        // }


        // document.body.addEventListener('focusin', (e) => {
        //     var that = this;
        //     //软键盘弹出的事件处理
        //     if (that.platform.is("ios") || that.platform.is("ipad") || that.platform.is("iphone")) {
        //         console.log("iso  kkkey tanchu", e);
        //     } else if (that.platform.is("android")) {
        //         console.log("android  kkkey tanchu", e);
        //     }
        // })
        // document.body.addEventListener('focusout', (e) => {
        //     var that = this;
        //     //软键盘收起的事件处理
        //     if (that.platform.is("ios") || that.platform.is("ipad") || that.platform.is("iphone")) {
        //         console.log("iso  kkkey tanchu", e);
        //     } else if (that.platform.is("android")) {
        //         console.log("android  kkkey tanchu", e);
        //     }

        // })


        //        window.addEventListener("focusin", function (e) {
        //      console.log("focusin",e.target["nodeName"]);
        //            console.log("focusin", e.target);
        //            if (app.ClickClientY > window.innerHeight - 250) {
        //             if(e.target&&e.target["style"] ){
        //                e.target["style"] = "position:fixed;left:0px; top:44px;height:30px; z-index:99999;background-color: white;"
        //            }
        //         }

        //  }, false);

        //  window.addEventListener("focusout", function (e) {
        //      console.log("focusout",e.target);

        //      console.log("focusout", e.target["nodeName"]);
        //      if (app.ClickClientY > window.innerHeight - 250) {
        //          if(e.target&&e.target["style"] ){
        //          e.target["style"] = "position:none;left:0px; top:44px; z-index:99999;height:30px;background-color: white;"
        //      }
        //     }
        //  }, false);
    }

    /**
     * 选择组织
     * @param e 
     */
    selectOrg(e) {
        console.log(e.detail.value);
        if (e.detail.value) {
            this.base.Department = e.detail.value;
        }
    }

    //手机型号
    MobileModel() {
        var type = navigator.userAgent;
        if (type && type.indexOf("MI 8") > -1) {
            if (document.body) {
                document.body.setAttribute("class", "alien-screen");
            }
        }
    }

    KeyBoard() {

        console.log("初始化ngafterviewinit");
        let ionapp = document.getElementsByTagName("ion-app")[0];
        //   window.addEventListener('native.keyboardhide', function (e) {
        //     // todo 进行键盘不可用时操作
        //     console.log("输入法隐藏",e);
        // });

        
        // window.addEventListener('native.keyboardshow', async (event) => {
        //     console.log("输入法输入keyboardshow1", JSON.stringify(event));
        //     // Move ion-app up, to give room for keyboard
        //     let kbHeight: number = event["keyboardHeight"];
        //     let viewportHeight: number = window.innerHeight;
        //     let inputFieldOffsetFromBottomViewPort: number = viewportHeight - $(':focus')[0].getBoundingClientRect().bottom;
        //     // let inputFieldOffsetFromBottomViewPort: number = viewportHeight - document.activeElement[0].getBoundingClientRect().bottom;
         
        //     let inputScrollPixels = kbHeight - inputFieldOffsetFromBottomViewPort;
        //     // if (app.ClickClientY > window.innerHeight / 2)
        //     // {
        //     //     inputScrollPixels = kbHeight - inputFieldOffsetFromBottomViewPort;
        //     // }else{
             
        //     // }
        //     // Set margin to give space for native keyboard.
        //     // ionapp.style["margin-bottom"] = kbHeight.toString() + "px";
        //     ionapp.style["margin-bottom"] = "0px";
        //     console.log("ion-app margin-botton", kbHeight.toString());
        //     console.log("ion-app margin-botton", inputScrollPixels.toString());


        //     // But this diminishes ion-content and may hide the input field...
        //     if (inputScrollPixels > 0) {
        //         // ...so, get the ionScroll element from ion-content and scroll correspondingly
        //         // The current ion-content element is always the last. If there are tabs or other hidden ion-content elements, they will go above.
        //         // let ionScroll = await $("ion-content").last()[0].getScrollElement();
        //         let ionContent = document.querySelectorAll("ion-content");
        //         let ionScroll = await ionContent[ionContent.length - 1].getScrollElement();
        //         console.log("ionScroll.scrollTop", ionScroll.scrollTop);
        //         setTimeout(() => {

        //             // if (app.ClickClientY > window.innerHeight -250)
        //             // {
        //             // $(ionScroll).animate({
        //             //     scrollTop: ionScroll.scrollTop + inputScrollPixels

        //             // }, 1000);
        //             // }
        //             console.log("inputScrollPixels", inputScrollPixels);
        //             // ionScroll.animate({
        //             //       scrollTop: ionScroll.scrollTop + inputScrollPixels
        //             //   }, 300);
        //             // ionScroll.scrollTop=ionScroll.scrollTop + inputScrollPixels;
        //         }, 300); // Matches scroll animation from css.
        //     }
        // });


        window.addEventListener('keyboardDidShow', async (event) => {
            console.log("输入法输入", event);
            // Move ion-app up, to give room for keyboard
            let kbHeight: number = event["keyboardHeight"];
            let viewportHeight: number = window.innerHeight;
            // let inputFieldOffsetFromBottomViewPort: number = viewportHeight - $(':focus')[0].getBoundingClientRect().bottom;
            let inputFieldOffsetFromBottomViewPort: number = viewportHeight - document.activeElement[0].getBoundingClientRect().bottom;

            let inputScrollPixels = kbHeight - inputFieldOffsetFromBottomViewPort;

            // Set margin to give space for native keyboard.
            ionapp.style["margin-bottom"] = kbHeight.toString() + "px";

            // But this diminishes ion-content and may hide the input field...
            if (inputScrollPixels > 0) {
                // ...so, get the ionScroll element from ion-content and scroll correspondingly
                // The current ion-content element is always the last. If there are tabs or other hidden ion-content elements, they will go above.
                // let ionScroll = await $("ion-content").last()[0].getScrollElement();
                let ionContent = document.querySelectorAll("ion-content");
                let ionScroll = await ionContent[ionContent.length - 1].getScrollElement();

                setTimeout(() => {

                    $(ionScroll).animate({
                        scrollTop: ionScroll.scrollTop + inputScrollPixels
                    }, 300);
                    // ionScroll.animate({
                    //       scrollTop: ionScroll.scrollTop + inputScrollPixels
                    //   }, 300);
                    ionScroll.scrollTop = ionScroll.scrollTop + inputScrollPixels;
                }, 300); // Matches scroll animation from css.
            }
        });
        window.addEventListener('keyboardDidHide', () => {
            // Move ion-app down again
            // Scroll not necessary.
            ionapp.style["margin-bottom"] = "0px";
        });

        window.addEventListener('native.keyboardhide', function (e) {
            // todo 进行键盘不可用时操作
            console.log("输入法隐藏", e);
            ionapp.style["margin-bottom"] = "0px";
        });
    }

}
